import ShadowHtml from "./ShadowHtml";
import { useSiteBanner } from "../../utils/bannerHelper";

export default function SiteBanner() {
  const { enabled, html } = useSiteBanner();

  if (!enabled || !html) return null;

  return (
    <div role="region" aria-label="Site announcement">
      <ShadowHtml html={html} />
    </div>
  );
}
